var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "上传检测结果",
        okText: "确定",
        cancelText: "取消",
        width: "800px",
        visible: _vm.visible,
        "confirm-loading": _vm.confirmLoading,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.formState,
            rules: _vm.rules,
            "label-col": { span: 8 },
            "wrapper-col": { span: 16 },
          },
        },
        [
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "受检单位名称",
                        prop: "checkerName",
                      },
                    },
                    [
                      _c("a-ext-bold-a", {
                        model: {
                          value: _vm.formState.checkerName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "checkerName", $$v)
                          },
                          expression: "formState.checkerName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "所属监测环节",
                        prop: "pickLink",
                      },
                    },
                    [
                      _c("a-ext-bold-a", {
                        model: {
                          value: _vm.formState.pickLink,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "pickLink", $$v)
                          },
                          expression: "formState.pickLink",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "检测品种",
                        prop: "pickType",
                      },
                    },
                    [
                      _c("a-ext-bold-a", {
                        model: {
                          value: _vm.formState.pickType,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "pickType", $$v)
                          },
                          expression: "formState.pickType",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "检测数量",
                        prop: "checkCount",
                      },
                    },
                    [
                      _c("a-ext-bold-a", {
                        model: {
                          value: _vm.formState.checkCount,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "checkCount", $$v)
                          },
                          expression: "formState.checkCount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "污染物信息",
                        prop: "badThings",
                      },
                    },
                    [
                      _c("a-ext-bold-a", {
                        model: {
                          value: _vm.formState.badThings,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "badThings", $$v)
                          },
                          expression: "formState.badThings",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "检测结果",
                        prop: "checkIsGood",
                      },
                    },
                    [
                      _c("a-ext-local-dic-select", {
                        attrs: {
                          disabled:
                            _vm.param.disabled ||
                            _vm.formState.checkIsGood === "不合格",
                          "dic-key": "MonitCheckResult",
                        },
                        model: {
                          value: _vm.formState.checkIsGood,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "checkIsGood", $$v)
                          },
                          expression: "formState.checkIsGood",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "检测单上传",
                        prop: "listCheckFiles",
                      },
                    },
                    [
                      _c("a-ext-muti-upload", {
                        attrs: {
                          disabled: _vm.param.disabled,
                          "belong-id": _vm.param.id,
                          "belong-type": "检测单",
                          "belong-small-type": "检测单",
                        },
                        model: {
                          value: _vm.formState.listCheckFiles,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "listCheckFiles", $$v)
                          },
                          expression: "formState.listCheckFiles",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "备注说明",
                        prop: "remark",
                      },
                    },
                    [
                      _c("a-textarea", {
                        attrs: {
                          disabled: _vm.param.disabled,
                          placeholder: "请输入备注说明",
                          "auto-size": { minRows: 2, maxRows: 6 },
                        },
                        model: {
                          value: _vm.formState.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "remark", $$v)
                          },
                          expression: "formState.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }